module.exports = __webpack_public_path__ + "img/kid.4db1f03d.svg";